import React, { useEffect, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import MyTable from '../../../utils/MyTable';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { useDispatch, useSelector } from "react-redux";

import { ClientAPI } from '../../../../API/client'

import { unoTheme, headerSearch } from '../../../../assets/styles/unoTheme'

import moment from 'moment'
import { applyMaskCpf, getMonthName, hasOnlyNumbers, isValidCpf, justNumbers } from "../../../utils/utils";
import allActions from "../../../../actions";

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },
  green: {
    color: 'green'
  },
  red: {
    color: 'red',
  },
  headerSearch: headerSearch,
  inputSearch: {
    width: "300px",
    background: "white"
  },
  toStickyHeader: {
    display: 'flex',
    height: '100%',
  }
}));

export default function ConciliationScreen({ search }) {

  const classes = useStyles();

  const clientOn = useSelector(state => state.clientOn)
  const [clientConciliations, setClientConciliations] = useState([]);
  const dispatch = useDispatch();

  async function doGetAllClientConciliations(clientId) {

    dispatch(allActions.innerLoadActions.setInnerLoad({
      show: true,
      loadMessage: 'Carregando conciliações...'
    }));

    let response = null;
    let isSearchInputValueEmpty = search === '';
    if (isSearchInputValueEmpty) {
      response = await ClientAPI.getAllClientConciliations(clientId);
    } else {
      response = await ClientAPI.getAllClientConciliationsByUser(clientId, search);
    }

    const conciliationLogsData = response.body.rows;

    if (response.success && response.body) {
      const hasConciliationLogsData = conciliationLogsData.length > 0 ? true : false;
      if (hasConciliationLogsData) {
        setClientConciliations(response.body.rows);
        dispatch(allActions.innerLoadActions.setInnerLoad({
          show: false
        }));
      } else {
        setClientConciliations([]);
        dispatch(allActions.innerLoadActions.setInnerLoad({
          show: true, emptyMessage: 'Não existem conciliações'
        }));
      }
    } else {
      console.error("RESPONSE ERROR: ", response.error);
      dispatch(allActions.innerLoadActions.setInnerLoad({
        show: false
      }));
    }
  }

  useEffect(() => {

    console.log("User effect")
    if (clientOn && clientOn.client && clientOn.client.id) {
      doGetAllClientConciliations(clientOn.client.id);
    }

  }, [search, clientOn]);

  return (
    <div className={classes.root}>
      <div class={'defaultScrollWithHeaderContent'}>
        <MyTable
          stickyHeader
          nofixed={true}
          size="small">
          <TableHead>
            <TableRow>
              <TableCell align="left">Data</TableCell>
              <TableCell align="left">Ativo</TableCell>
              <TableCell align="center">Mês</TableCell>
              <TableCell align="center">Ano</TableCell>
              <TableCell align="center">Usuário</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {clientConciliations.map((row, index) => (
              <TableRow key={'conciliations-' + index}>
                <TableCell align="left" style={{ color: unoTheme.mainColor }}>{moment(row.conc_date).format('DD/MM/YYYY - HH:mm:ss')}</TableCell>
                <TableCell align="left">{row.fund_name} - CC: {row.number_account}</TableCell>
                <TableCell align="center">{getMonthName(row.month)}</TableCell>
                <TableCell align="center">{row.year}</TableCell>
                <TableCell align="center">{row.username.toUpperCase()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </MyTable>
      </div>
    </div>
  );
}



